import { useState } from "react"
import { ChevronDown, ChevronUp, Lock, Trash2 } from "react-bootstrap-icons"
import BreakdownLineItem from "./BreakdownLineItem"


export const ToggleWF = ({ title, locked, deleted, children }) => {
    const [show, setShow] = useState(false)
    return (
        <div className=" collapsable">
            <div className="d-flex " onClick={e => setShow(!show)}>
                <div className="flex-grow-1">
                    {locked && <Lock />}
                    {deleted && <Trash2 />}
                    {title}
                </div>

                <div>
                    {show ? <ChevronUp /> : <ChevronDown />}
                </div>
            </div>
            <div className={`${!show ? 'slide-up' : 'slide-down'}`}>
                {children}
            </div>
        </div>)

}

export const FacilityBreakdownWorkFlowComponent = ({ workflow }) => {
    return (<div className="bg-light text-dark rounded p-2 m-2" style={{ fontSize: '1rem' }}>
        <ToggleWF title={`${workflow.group.name} : ${workflow.name}`} locked={workflow.isSystemLocked} deleted={workflow.isDeleted}>
            <div>
                <BreakdownLineItem workflow={workflow} />
                {workflow.triggers &&
                    <div className='ms-2'>
                        {/* <b>Triggers</b> */}
                        {
                            workflow.triggers.map(t => <div>
                                {/* {t.type.description}
                            {{
                                ...TriggerDetailsByType[t.type.key],
                                props: {
                                    ...TriggerDetailsByType[t.type.key].props,
                                    properties: t.properties
                                }

                            }} */}
                                {/* {t.properties &&
                            <div className='ms-4'>
                                <b>Properties</b>
                                <table className='table table-sm'>
                                    <thead>
                                        <tr>
                                            <th>Property</th>
                                            <th>Value</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {t.properties.map(p =>
                                            <tr>
                                                <td>{p.property && p.property}</td>
                                                <td>{p.value && p.value}</td>
                                            </tr>
                                        )
                                        }
                                    </tbody>
                                </table>
                            </div>
                        } */}
                            </div>)}
                    </div>
                }
                {/* {workflow.tasks &&
                <div className='ms-2'>
                    <b>Tasks</b>
                    {workflow.tasks.map(t => <div>
                        {t.taskName} {t.isDeleted && 'Deleted'}
                        {t.properties &&
                            <div className='ms-4'>
                                <b>Properties</b>
                                <table className='table table-sm' style={{ tableLayout: 'fixed' }}>
                                    <thead>
                                        <tr>
                                            <th>Property</th>
                                            <th>Value</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {t.properties.map(p =>
                                            <BasicTableTaskPropertiesComponent props={p} />
                                        )
                                        }
                                    </tbody>
                                </table>
                            </div>
                        }
                    </div>)}
                </div>
            } */}
            </div>
            <hr />
        </ToggleWF>
    </div>)
}
